import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ComplexStore } from '../stores/complex.store';
import { AppRoutes } from '../constants/routes';

/**
 * Holds the management app shut once SmartPlayr has closed it to the venue.
 *
 * The Partner Terms let the platform deactivate a venue that keeps the software but stops taking
 * bookings through it (Sections 2 and 12). The server refuses every admin call of such a venue;
 * this guard is the courtesy that turns those refusals into one screen that says why, and who to
 * write to, instead of a dashboard where every button fails.
 *
 * Everyone at the venue, owner and staff alike — the sanction is on the venue, not on a person.
 *
 * Sits on the dashboard shell ahead of the terms gate: a locked-out venue is never asked to sign
 * anything. Never blocks on an unknown state, matching the other guards in this folder.
 */
export const managementAccessGuard: CanActivateFn = async () => {
  const complexStore = inject(ComplexStore);
  const router = inject(Router);

  await complexStore.ensureLoaded();

  return complexStore.managementDisabled()
    ? router.createUrlTree([AppRoutes.AccessClosed])
    : true;
};
